import { ReportingShellControllerBaseConfig } from '../../../base';
import { InsertOverviewController } from './InsertOverviewInterface';
import { InsertOverviewViewProps } from './InsertOverviewProps';
import { InsertTemplateItemProps } from './template';
import { InsertComponentItemProps } from './component';
import { InsertComponentEntity } from '@varos/research-react';
import { InsertTemplateEntity } from '@varos/platform-react';

export function createInsertOverviewController(
    config: ReportingShellControllerBaseConfig
): InsertOverviewController {
    const {} = config;

    // Map entity to UI model
    const mapTemplateEntityToUI = (
        entity: InsertTemplateEntity
    ): InsertTemplateItemProps => ({
        id: entity.id,
        label: entity.title,
        description: entity.description,
        caption: entity.summary,
        author: entity.author,
        icon: {
            kind: 'emoji',
            value: entity.icon,
        },
    });

    const mapComponentEntityToUI = (
        entity: InsertComponentEntity
    ): InsertComponentItemProps => ({
        id: entity.id,
        label: entity.name,
        description: entity.description,
        caption: entity.summary,
        icon: {
            kind: 'emoji',
            value: entity.icon,
        },
    });

    return {
        useProps(context, item, props): InsertOverviewViewProps {
            // Map tab value to index for the view
            const tabIndex = props.field.tab.value === 'template' ? 0 : 1;

            return {
                search: {
                    input: {
                        autoFocus: true,
                        placeholder: 'Search for a use-case',
                        value: props.field.search.value,
                        onChange(event) {
                            props.field.search.onChange(event.target.value);
                        },
                    },
                },
                tabs: {
                    root: {
                        isLazy: true,
                        index: tabIndex,
                        onChange: (index: number) => {
                            const tabValue = index === 0 ? 'template' : 'block';
                            props.field.tab.onChange(tabValue);
                        },
                    },
                    items: [
                        {
                            id: 'templates',
                            kind: 'template',
                            label: 'Templates',
                            items: item.templates.map(mapTemplateEntityToUI),
                            footer: {
                                label: 'Explore more templates',
                                button: {
                                    onClick: () => {
                                        // TODO: Handle template footer button click
                                    },
                                },
                            },
                        },
                        {
                            id: 'blocks',
                            kind: 'block',
                            label: 'Components',
                            items: item.components.map(mapComponentEntityToUI),
                            footer: {
                                label: 'Explore more components',
                                button: {
                                    onClick: () => {
                                        // TODO: Handle component footer button click
                                    },
                                },
                            },
                        },
                    ],
                },
            };
        },
    };
}
